import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { LOCATION_ACTIVE_URL } from "api/Service";

// Locations available for booking. The booking form uses this list to decide
// whether to show a picker at all: exactly one → auto-select and hide it
// (see AddAppointmentForm); more than one → show the picker, defaulting to
// whichever entry has isDefault === true.
export const useActiveLocations = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["locationsActive", tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}${LOCATION_ACTIVE_URL}`
      );

      return response.data;
    },
    enabled: !!tenantVal,
    staleTime: 5 * 60 * 1000,
  });
};
